import type * as React from 'react';
import { ConfigurationCardGroup } from '../ConfigurationCardGroup.tsx';

export type WidgetConfigurationCardGroupProps = React.ComponentProps<
  typeof ConfigurationCardGroup
>;

/**
 * Alias del `ConfigurationCardGroup` per il Drawer di configurazione dei Widget.
 */
export function WidgetConfigurationCardGroup(
  props: WidgetConfigurationCardGroupProps,
) {
  return <ConfigurationCardGroup {...props} />;
}
